import _union from 'lodash/union';

import { makeBtStyles } from './Theme';
import {Branding, Link, SocialLink, BrandingPropertiesPoweredBy} from './apiTypes';

export function weightAsLbsAndOunces(weightInOunces: number) {
  const OUNCES_PER_POUND = 16;
  const lbs = Math.floor(weightInOunces / OUNCES_PER_POUND);
  const ounces = Math.round(((weightInOunces - (lbs * OUNCES_PER_POUND)) * 100)) / 100;
  return [lbs, ounces];
}

export type StyleDef = object | (() => object);

export function makeOverridableStyles(baseStyles: any, styleOverrides: any, makeStylesOptions: any) {
  return makeBtStyles( theme => {
    const styles: any = {};

    const baseStylesObj = (typeof baseStyles === 'function') ? baseStyles(theme) : baseStyles || {};
    const styleOverridesObj = (typeof styleOverrides === 'function') ? styleOverrides(theme) : styleOverrides || {};

    _union( Object.keys(baseStylesObj), Object.keys(styleOverridesObj) ).forEach( key => {
      const baseStyle = baseStylesObj[key] || {};
      const styleOverride = styleOverridesObj[key] || {};

      if( (typeof baseStyle === 'function') || (typeof styleOverride === 'function') ) {
        styles[key] = (params: any) => ({
          ...( (typeof baseStyle === 'function') ? baseStyle(params) : baseStyle),
          ...( (typeof styleOverride === 'function') ? styleOverride(params) : styleOverride)
        });
      }
      else {
        styles[key] = { ...baseStyle, ...styleOverride };
      }
    });

    return styles;
  }, makeStylesOptions );
}


export function transformV1BrandingToV2(branding: BrandingCompatV1) {
  if (!branding)
    return null;

  if (branding?._API_VERSION)
    return branding;
  
  let {
    branded_tracking_config_id,
    menuLinks,
    socialMedia,
    ...brandingV2
  }: {
    branded_tracking_config_id: string,
    menuLinks: Array<MenuLinkCompatV1> | null,
    socialMedia: Array<SocialLinkCompatV1> | null,
    brandingV2: Branding
  } =
      {
        ...branding,
        // @ts-ignore
        branding_id: branding.branded_tracking_config_id,
        menu_links: branding.menuLinks?.map((ml: MenuLinkCompatV1) =>
                ({url: ml.link, text: ml.text}) as Link) ?? [],
        social_media: branding.socialMedia?.map((ml: SocialLinkCompatV1) =>
            ({url: ml.handle, type: ml.type}) as SocialLink) ?? [],
        external_links: [],
        powered_by: branding && 'powered_by' in branding && branding.powered_by !== null ? ({
          // @ts-ignore
          logo_url: branding.powered_by.logo_url,
          // @ts-ignore
          name: branding.powered_by.name,
          // @ts-ignore
          url: branding.powered_by.url
        }) as BrandingPropertiesPoweredBy : null
      };
  return brandingV2;
}

interface BrandingCompatV1 extends Branding {
  _API_VERSION: string;
  branded_tracking_config_id: string;
  menuLinks?: Array<MenuLinkCompatV1> | null;
  socialMedia?: Array<SocialLinkCompatV1> | null;
}

export interface MenuLinkCompatV1 {
  link: string,
  text: string
}

export interface SocialLinkCompatV1 {
  handle: string,
  type: string
}
